import React from 'react';
import PropTypes from 'prop-types';
import style from 'components/Image/Image.style';

const Image = ({
  file,
  title,
  className,
  width,
  height,
  fill,
  stretchWidth,
  contentType,
  noItem,
}) => {
  if (noItem) {
    return null;
  }

  let imageHeight = file.details.image.height;
  let imageWidth = file.details.image.width;

  let fillText = '';

  if (fill) {
    fillText = '&fit=fill';
  }

  const ratio = imageHeight / imageWidth;
  let changeSize = true;

  if (height && width) {
    imageHeight = height;
    imageWidth = width;
  } else if (height && !width) {
    imageHeight = height;
    imageWidth = Math.floor(imageHeight / ratio);
    fillText = '&fit=fill';
  } else if (!height && width) {
    imageWidth = width;
    imageHeight = Math.floor(ratio * imageWidth);
    fillText = 'fit=fill';
  } else {
    changeSize = false;
  }

  let jpg = '';

  if (contentType === 'image/jpeg') {
    jpg = 'fm=jpg&fl=progressive';
  }

  let url;

  if (changeSize) {
    url = `${file.url}?w=${imageWidth}&h=${imageHeight}&${fillText}&${jpg}`;
  } else {
    url = `${file.url}?${jpg}`;
  }

  let imageStyles = style.image;

  if (stretchWidth) {
    imageStyles = { ...imageStyles, width: stretchWidth };
  }

  return (
    <img
      style={imageStyles}
      width={imageWidth}
      height={imageHeight}
      src={url}
      className={className}
      alt={title}
    />
  );
};

Image.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string,
    details: PropTypes.shape({
      image: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
      }),
    }),
  }).isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.bool,
  title: PropTypes.string,
  stretchWidth: PropTypes.number,
  contentType: PropTypes.string.isRequired,
  noItem: PropTypes.bool,
};

Image.defaultProps = {
  className: null,
  width: null,
  height: null,
  fill: true,
  title: 'Content editor has not supplied alt text',
  stretchWidth: null,
  noItem: false,
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.jsx